/**
 * Store Info Transformer
 * Handles transformation of store information from API to application domain model
 * Single Responsibility: Store info data transformation only
 */

/**
 * Transforms raw store API response to application model
 * @param {Object} rawResponse - Raw JSON response from API
 * @returns {Object} Transformed store object
 */
export function transformStoreInfo(rawResponse) {
  // The API returns 'store' field as the store ID (not 'id')
  // Extract store ID from 'store' field if it's a number or parse it
  const storeId =
    rawResponse.id ||
    (typeof rawResponse.store === "number"
      ? rawResponse.store
      : parseInt(rawResponse.store)) ||
    null;

  return {
    id: storeId,
    store: rawResponse.store, // Keep original store field for backward compatibility
    name: rawResponse.name || "",
    displayName: rawResponse.display_name || rawResponse.displayName || "",
    phone: rawResponse.phone || "",
    dashboardLink: rawResponse.dashboard_link || "",
    alias: rawResponse.alias || "",
    // Add any other fields you need, normalized to camelCase
    ...rawResponse
  };
}
